import { render, staticRenderFns } from "./freightDetails.vue?vue&type=template&id=73be4efb&scoped=true"
import script from "./freightDetails.vue?vue&type=script&lang=js"
export * from "./freightDetails.vue?vue&type=script&lang=js"
import style0 from "./freightDetails.vue?vue&type=style&index=0&id=73be4efb&prod&lang=scss"
import style1 from "./freightDetails.vue?vue&type=style&index=1&id=73be4efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73be4efb",
  null
  
)

export default component.exports